import { PRODUCT_TABLE_TYPES } from '../../../lib/constants';

const tableComponent = PRODUCT_TABLE_TYPES.EXPANDING;

const columns = (id) => [
  {
    name: 'Broker',
    mobileOrder: 1,
    elements: [
      {
        type: 'ApplyNow',
        props: {
          logoLink: true,
          impressionId: `logo-${id}`,
        },
      },
      {
        type: 'StarRating',
      },
    ],
  },
  {
    name: 'Highlights',
    hideOnMobile: true,
    elements: [
      {
        type: 'Label',
        props: {
          textPath: 'additional_data.summary_short',
        },
      },
    ],
  },
  {
    name: 'Commissions',
    mobileOrder: 2,
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactFees',
        },
      },
    ],
  },
  {
    name: 'Account Minimum',
    mobileOrder: 4,
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactAccountMinimum',
        },
      },
    ],
  },
  {
    name: 'Current Offers',
    mobileOrder: 3,
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactPromotion',
        },
      },
    ],
  },
  {
    name: 'Start Investing',
    mobileOrder: 5,
    elements: [
      {
        type: 'ApplyNow',
        props: {
          ctaCopy: 'Learn More',
          hideIcon: true,
          impressionId: `cta-${id}`,
        },
      },
    ],
  },
];

export default {
  columns,
  tableComponent,
};
